module.exports = __webpack_public_path__ + "static/media/case.3b7c8801.svg";